module.exports = __webpack_public_path__ + "static/img/Nosotros_Lapiz.cb1a9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/Nosotros_Lapiz.png
// module id = 5
// module chunks = 0